import { Socials } from "../home/socials";
import logoWhite from "assets/logo-white.svg";
import HomeNewsletterForm from "../home/newsletter";
import { Card, CardBody } from "@nextui-org/react";
import { classNames, goToTop } from "utils/helper/helper";
import { Link } from "react-router-dom";
import EmailButton from "components/email/button";
import { encodeEmail } from "utils/hooks/useDecodedEmail";
import { authLinks } from "utils/helper/links";
const footerLinks = [
  {
    label: "About",
    uri: "https://cusorcart.com/about",
  },
  {
    label: "Become a vendor",
    uri: authLinks.register,
  },
  // {
  //   label: "Careers",
  //   uri: "https://cusorcart.com/about",
  // },
];
const Footer = () => {
  return (
    <>
      <footer className="relative py-4 pt-48 md:pt-36 lg:pt-36 px-6 xl:px-24 bg-[#004B68] text-white">
        <Card className="!absolute -top-[180px] md:-top-[80px] lg:-top-[80px] mx-6 xl:mx-24 inset-x-0 py-6 bg-white">
          <CardBody
            className={classNames(
              "divide-y-2 md:divide-x-2 lg:divide-x-2 md:divide-y-0 lg:divide-y-0 divide-primary",
              "md:grid lg:grid md:grid-cols-2 lg:grid-cols-2",
              "centered flex-col gap-2 md:gap-0 lg:gap-0"
            )}
          >
            <EmailButton cfEmail={encodeEmail("vendor@cusorcart.com")} />
            <a
              href="tel:02013306402"
              className="centered flex-col md:flex-row lg:flex-row gap-2 text-primary hover:text-secondary"
            >
              <svg
                width={100}
                height={100}
                className="w-14 lg:w-20"
                viewBox="0 0 100 100"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx={50} cy={50} r={50} fill="currentColor" />
                <g clipPath="url(#clip0_1721_5721)">
                  <path
                    d="M65 57.3667V63.26C65.0002 63.682 64.8403 64.0883 64.5527 64.397C64.265 64.7057 63.8709 64.8938 63.45 64.9233C62.7217 64.9733 62.1267 65 61.6667 65C46.9383 65 35 53.0617 35 38.3333C35 37.8733 35.025 37.2783 35.0767 36.55C35.1062 36.1291 35.2943 35.735 35.603 35.4473C35.9117 35.1597 36.318 34.9998 36.74 35H42.6333C42.8401 34.9998 43.0395 35.0764 43.1929 35.215C43.3463 35.3536 43.4427 35.5443 43.4633 35.75C43.5017 36.1333 43.5367 36.4383 43.57 36.67C43.9012 38.9815 44.58 41.2297 45.5833 43.3383C45.7417 43.6717 45.6383 44.07 45.3383 44.2833L41.7417 46.8533C43.9408 51.9774 48.0242 56.0609 53.1483 58.26L55.715 54.67C55.8199 54.5233 55.973 54.4181 56.1475 54.3728C56.322 54.3274 56.5069 54.3447 56.67 54.4217C58.7784 55.4231 61.026 56.1002 63.3367 56.43C63.5683 56.4633 63.8733 56.5 64.2533 56.5367C64.4587 56.5577 64.649 56.6543 64.7873 56.8076C64.9255 56.961 65.0019 57.1602 65.0017 57.3667H65Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1721_5721">
                    <rect
                      width={40}
                      height={40}
                      fill="white"
                      transform="translate(30 30)"
                    />
                  </clipPath>
                </defs>
              </svg>

              <span>+234 201 330 6402</span>
            </a>
          </CardBody>
        </Card>
        <div className="divide-y-1 divide-white space-y-4">
          <div className="grid lg:grid-cols-3 gap-x-12 gap-y-14 pb-12">
            <div className="space-y-4">
              <Link to={"/"} className="flex items-center" onClick={goToTop}>
                <img
                  src={logoWhite}
                  alt="CusorCart Logo"
                  className="h-7 w-auto"
                />
              </Link>
              <p className="dark:text-woodsmoke-300">
                Subscribe to keep in touch with our price offerings
              </p>
              <div className="">
                <Socials className="w-6 h-auto text-white" toLeft={true} />
              </div>
            </div>
            <div className="space-y-6">
              <span className="text-white text-xl lg:text-2xl font-semibold capitalize">
                Quick links
              </span>
              <ul className="dark:text-woodsmoke-300 flex flex-col space-y-3 text-base font-medium">
                {footerLinks.map((item, a) => (
                  <li key={a}>
                    <Link
                      className="hover:text-secondary dark:hover:text-white"
                      to={item.uri}
                      onClick={goToTop}
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
                <li>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-secondary dark:hover:text-white"
                    href={"https://hub.cusorcart.com"}
                  >
                    Blog
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-secondary dark:hover:text-white"
                    href={"https://help.cusorcart.com"}
                  >
                    Help Center
                  </a>
                </li>
              </ul>
            </div>

            <div className="space-y-6">
              <span className="text-white text-xl lg:text-2xl font-semibold capitalize">
                newsletter
              </span>
              <p className="dark:text-woodsmoke-300">
                Subscribe to keep in touch with our price offerings
              </p>
              <HomeNewsletterForm show={false} />
            </div>
          </div>
          <div className="flex flex-col items-center justify-center space-y-2 py-8 sm:flex-row sm:space-y-0">
            <span className="dark:text-woodsmoke-400 text-sm text-center">
              <span>
                © {"Copyright "}
                {new Date().getFullYear()}
                {/* */} {"Cusorcart. All Right Reserved."}
              </span>
            </span>
          </div>
        </div>
      </footer>

      <dialog id="newsletter_toast" className="modal">
        <div className="modal-box dark:bg-white">
          <div className="flex-col justify-center items-center flex">
            <div className="w-full pb-2 rounded-lg justify-start items-start gap-2.5 inline-flex">
              <div className="grow shrink basis-0 flex-col justify-center items-center gap-3 inline-flex">
                <div className="justify-center items-center inline-flex w-full">
                  <svg
                    className="w-full h-auto rounded-lg"
                    width={344}
                    height={120}
                    viewBox="0 0 344 120"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                  >
                    <rect
                      width={344}
                      height={120}
                      rx={8}
                      fill="url(#pattern0_3057_917)"
                    />
                    <defs>
                      <pattern
                        id="pattern0_3057_917"
                        patternContentUnits="objectBoundingBox"
                        width={1}
                        height={1}
                      >
                        <use
                          xlinkHref="#image0_3057_917"
                          transform="matrix(0.00199601 0 0 0.00572189 0 -0.358283)"
                        />
                      </pattern>
                      <image
                        id="image0_3057_917"
                        width={501}
                        height={300}
                        xlinkHref="data:image/png;base64,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"
                      />
                    </defs>
                  </svg>
                </div>
                <div className="self-stretch text-center text-[#1e3759] text-base font-semibold leading-normal">
                  Welcome Onboard
                </div>
                <div className="self-stretch text-center text-[#09131f] text-sm font-normal leading-snug">
                  Happy to have you as a cusor shopper! We have sent you an
                  email with your coupon codes
                </div>
              </div>
            </div>
            <div className="self-stretch h-[63px] py-4 rounded-bl-lg rounded-br-lg border-t border-[#222226]/10 flex-col justify-start items-start gap-4 flex">
              <form
                method="dialog"
                className="self-stretch rounded-2xl justify-start items-start inline-flex"
              >
                <button className="btn btn-secondary w-full">Ok</button>
              </form>
            </div>
          </div>
        </div>
      </dialog>
    </>
  );
};

export default Footer;
